import React from 'react';
import { Mail, Check } from 'lucide-react';

const EmailSendingAnimation = ({ isVisible }) => {
  if (!isVisible) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center space-y-4 relative overflow-hidden">
        <div className="flex items-center justify-center w-full">
          <div className="relative">
            <Mail className="w-12 h-12 text-blue-500 animate-bounce" />
            <div className="absolute -right-2 -top-2">
              <div className="animate-spin w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full" />
            </div>
          </div>
        </div>
        <p className="text-lg font-medium text-gray-700">Sending Email...</p>
        <div className="w-48 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-blue-500 animate-[loading_2s_ease-in-out_infinite]" 
               style={{
                 animation: 'loading 2s ease-in-out infinite',
               }} />
        </div>
        <style jsx>{`
          @keyframes loading {
            0% { width: 0%; }
            50% { width: 100%; }
            100% { width: 0%; }
          }
        `}</style>
      </div>
    </div>
  );
};

export default EmailSendingAnimation;